export default "__VITE_ASSET__CFzq4Oo1__"